export const currentQueryParams = new URLSearchParams(
  typeof window !== "undefined" ? window.location.search : "",
);
